import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'
import { RemoteLoadConstruct } from '../../../data/usecases/load-construct/remote-load-construct'

export const makeLoadConstruto = () => new RemoteLoadConstruct('/cotacao/construtosLoad', makeAxiosHttpClient())
